import type * as lazyIndex from './lazyIndex';
import { createLazyComponent, LazyAction, type LazyComponent, LazyModule } from 'owa-bundling';
import type { OwaHeaderAppLauncherContentProps } from './components/OwaHeaderAppLauncherContent';
import OwaHeaderAppLauncherLoading from './components/OwaHeaderAppLauncherLoading';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(
    () => import(/* webpackChunkName: "OwaHeaderAppLauncher"*/ './lazyIndex'),
    { name: 'OwaHeaderAppLauncher' }
);

export const LazyOwaHeaderAppLauncherContent: LazyComponent<
    OwaHeaderAppLauncherContentProps,
    unknown,
    void
> = createLazyComponent(
    lazyModule,
    m => m.OwaHeaderAppLauncherContent,
    OwaHeaderAppLauncherLoading
);

export const lazyPrefetchPinnedApps: LazyAction<
    typeof lazyIndex.prefetchPinnedApps,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.prefetchPinnedApps);
